<template>
  <footer class="footer">
    <div class="footer__content">
      <div class="footer__inner">
        <div class="footer__row">
          <a href="https://delayfix.com/" active-class="active" class="logo show-mobile"><Logo/></a>
          <div class="col-contact">
            <a href="https://delayfix.com/" active-class="active" class="logo"><Logo/></a>
            <p class="strong">{{ $t('footer.claim') }} </p>
            <p>
              <span v-html="$t('footer.contact-us')"/><br>
              {{ $t('footer.weekdays-hours') }}<br>
              <span v-html="$t('footer.on-weekends')"/><br>
              {{ $t('footer.saturday-hours') }}
            </p>
            <div>
              <a :href="`tel:${$t('footer.contact-number-href')}`" class="contact-link">{{ $t('footer.contact-number') }}</a>
            </div>
            <div>
              <a :href="`mailto:${$t('footer.contact-email')}`" class="contact-link">{{ $t('footer.contact-email') }}</a>
            </div>
          </div>
          <div class="col-links-socials">
            <p class="strong">{{ $t('footer.follow') }}</p>
            <socials :exclude="['twitter']"/>
          </div>
          <div class="col-links-pages">
            <ul class="page-links">
              <li class="page-link-wrap"><a href="https://delayfix.com/form/" class="page-link">{{ $t('check-compensation') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/twoje-prawa" class="page-link">{{ $t('passenger-rights') }}</a></li>
              <li class="page-link-wrap"><a :href="`https://delayfix.com/documents/terms/DelayFix-terms_${this.$i18n.locale}.pdf`" target="_blank" class="page-link">{{ $t('terms') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/blog" class="page-link">{{ $t('blog') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/faq/" class="page-link">FAQ</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/kontakt" class="page-link">{{ $t('contact') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/o-nas" class="page-link">{{ $t('footer.about') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/polityka-prywatnosci" class="page-link">{{ $t('privacy-policy') }}</a></li>
              <li class="page-link-wrap"><a href="https://delayfix.com/polityka-prywatnosci#gdpr'" class="page-link">{{ $t('gdpr') }}</a></li>
              <li class="page-link-wrap"><a v-if="$i18n.locale === 'pl'" href="https://delayfix.com/wersje-archiwalne-regulaminu" class="page-link">Wersje archiwalne regulaminu</a></li>
            </ul>
          </div>
          <div class="col-company">
            <p class="strong">
              {{ $t('footer.company.name') }}<br>
              {{ $t('footer.company.address-1') }}<br>
              {{ $t('footer.company.address-2') }}
            </p>
            <p>{{ $t('footer.company.registration') }}</p>
            <p>{{ $t('footer.company.nip') }}</p>
            <p>{{ $t('footer.company.capital-1') }}<br>{{ $t('footer.company.capital-2') }}</p>
          </div>
          <div class="col-copyrights">
            &copy; {{ currentYear }} DelayFix
          </div>
        </div>
      </div>
    </div>
    <div class="socials-wrap">
      <socials :exclude="['twitter']" round/>
    </div>
  </footer>
</template>

<script>
import Socials from '@/components/Socials'
import Logo from '@/components/Logo'

export default {
  components: {
    Socials,
    Logo
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    background-color: $gray-light;

    &__row {
      @include grid-row;
      padding-top: 40px;
      padding-bottom: 27px;

      @include media-down(lg) {
        padding-top: 58px;
        padding-bottom: 79px;
      }

      @include media-down(md) {
        padding-top: 94px;
        padding-bottom: 35px;
      }
    }

    &__inner {
      @include grid-container;
      display: flex;
      flex-wrap: wrap;
    }

    &__content {
      background-color: $teal;

      p {
        margin-bottom: 1.5em;
      }
    }
  }

  .logo {
    display: flex;
    margin-bottom: 4em;

    svg {
      height: 2em;

      /deep/ > * {
        fill: $beige;
      }
    }

    &.show-mobile {
      @include grid-column((xs: 12));
    }

    @include media-down(lg) {
      .col-contact & {
        display: none;
      }
    }

    @include media-up(lg) {
      &.show-mobile {
        display: none
      }
    }
  }

  .footer,
  .contact-link {
    font-weight: 300;
    color: $beige;
    @include font-small;
  }

  .strong,
  .contact-link {
    font-weight: 500;
  }

  .col-contact,
  .col-links-pages,
  .col-links-socials,
  .col-company {
    position: relative;

    &:after {
      position: absolute;
      left: 12px;
      bottom: 0;
      width: calc(100% - 12px);
      height: 1px;
      background-color: #fff;

      @include media-down(md) {
        width: calc(100% - 30px);
        left: 15px;
      }
    }
  }

  .col-contact {
    @include grid-column((xs: 12, md: 6, lg: 3));

    @include media-up(md) {
      font-size: 14px;
    }

    @include media-down(lg) {
      padding-bottom: 34px;

      &:after {
        content: '';
      }
    }
  }

  .col-links-socials {
    @include grid-column((xs: 12, md: 6, lg: 2));
    @include grid-offset((xs: 0, lg: 2));

    @include media-down(lg) {
      padding-bottom: 34px;

      &:after {
        content: '';
        left: 0;
      }
    }

    @include media-down(md) {
      padding-top: 50px;
      padding-bottom: 50px;

      &:after {
        left: 15px;
      }
    }
  }

  .col-links-pages {
    @include grid-column((xs: 12, md: 6, lg: 2));

    .contact-link {
      display: inline-block;
      margin-bottom: 1.5em;
      font-weight: 500;
      @include font-small;
    }

    @include media-down(lg) {
      padding-top: 34px;
    }

    @include media-down(md) {
      padding-top: 50px;
      padding-bottom: 50px;

      &:after {
        content: '';
      }
    }
  }

  .col-company {
    @include grid-column((xs: 12, md: 6, lg: 3));

    @include media-down(lg) {
      padding-top: 34px;
    }

    @include media-down(md) {
      padding-top: 50px;
    }
  }

  .col-copyrights {
    @include grid-column((xs: 12, md: 6, lg: 3));
    @include grid-offset((xs: 0, md: 6, lg: 9));

    @include media-down(md) {
      margin-top: 90px;
    }
  }

  .socials-wrap {
    padding: 20px 0;

    ul {
      display: flex;
      justify-content: center;
    }
  }

  .page-link {
    display: inline-block;
    margin-bottom: 1.5em;
    font-weight: 500;
    color: $beige;
    @include font-small;
  }
</style>
